import api from "../api/persons";
import types from "./types";
import {createError, logError} from "../../../../ui/Notify";

function requestPersons() {
  return {
    type: types.GET_PERSONS_REQUEST,
    isFetchingList: true
  };
}

function requestPersonsCompleted(persons) {
  return {
    type: types.GET_PERSONS_COMPLETED,
    isFetchingList: false,
    persons
  };
}

function requestPersonsError(personsError) {
  return {
    type: types.GET_PERSONS_ERROR,
    isFetchingList: false,
    personsError
  };
}

function requestPersonHistory() {
  return {
    type: types.GET_PERSON_HISTORY_REQUEST,
    isFetchingHistory: true
  };
}

function requestPersonHistoryCompleted(history) {
  return {
    type: types.GET_PERSON_HISTORY_COMPLETED,
    isFetchingHistory: false,
    history
  };
}

function requestPersonHistoryError(historyError) {
  return {
    type: types.GET_PERSON_HISTORY_ERROR,
    isFetchingHistory: false,
    historyError
  };
}

function requestPersonRoles() {
  return {
    type: types.GET_PERSON_ROLES_REQUEST,
    isFetchingRoleList: true
  };
}

function requestPersonRolesCompleted(roles) {
  return {
    type: types.GET_PERSON_ROLES_COMPLETED,
    isFetchingRoleList: false,
    roles
  };
}

function requestPersonRolesError(rolesError) {
  return {
    type: types.GET_PERSON_ROLES_ERROR,
    isFetchingRoleList: false,
    rolesError
  };
}

function requestPersonWs() {
  return {
    type: types.GET_PERSON_WS_REQUEST,
    isFetchingWsList: true
  };
}

function requestPersonWsCompleted(worldSkills) {
  return {
    type: types.GET_PERSON_WS_COMPLETED,
    isFetchingWsList: false,
    worldSkills
  };
}

function requestPersonWsError(wsError) {
  return {
    type: types.GET_PERSON_WS_ERROR,
    isFetchingWsList: false,
    wsError
  };
}

function requestPersonSkills() {
  return {
    type: types.GET_PERSON_SKILLS_REQUEST,
    isFetchingSkillList: true
  };
}

function requestPersonSkillsCompleted(skills) {
  return {
    type: types.GET_PERSON_SKILLS_COMPLETED,
    isFetchingSkillList: false,
    skills
  };
}

function requestPersonSkillsError(skillsError) {
  return {
    type: types.GET_PERSON_SKILLS_ERROR,
    isFetchingSkillList: false,
    skillsError
  };
}

function requestPersonAttachments() {
  return {
    type: types.GET_PERSON_DOCUMENT_ATTACHMENTS_REQUEST,
    isFetchingAttachList: true
  };
}

function requestPersonAttachmentsCompleted(attachments) {
  return {
    type: types.GET_PERSON_DOCUMENT_ATTACHMENTS_COMPLETED,
    isFetchingAttachList: false,
    attachments
  };
}

function requestPersonAttachmentsError(attachmentsError) {
  return {
    type: types.GET_PERSON_DOCUMENT_ATTACHMENTS_ERROR,
    isFetchingAttachList: false,
    attachmentsError
  };
}

function requestPersonSnilsAttachments() {
  return {
    type: types.GET_PERSON_SNILS_ATTACHMENTS_REQUEST,
    isFetchingSnilsAttachList: true
  };
}

function requestPersonSnilsAttachmentsCompleted(attachmentsSnils) {
  return {
    type: types.GET_PERSON_SNILS_ATTACHMENTS_COMPLETED,
    isFetchingSnilsAttachList: false,
    attachmentsSnils
  };
}

function requestPersonSnilsAttachmentsError(attachmentsError) {
  return {
    type: types.GET_PERSON_SNILS_ATTACHMENTS_ERROR,
    isFetchingSnilsAttachList: false,
    attachmentsSnilsError: attachmentsError
  };
}

function requestPerson() {
  return {
    type: types.GET_PERSON_REQUEST,
    isFetchingPerson: true
  };
}

function requestPersonCompleted(personCard) {
  return {
    type: types.GET_PERSON_COMPLETED,
    isFetchingPerson: false,
    personCard
  };
}

function requestPersonError(personCardError) {
  return {
    type: types.GET_PERSON_ERROR,
    isFetchingPerson: false,
    personCardError
  };
}

function requestFullPerson() {
  return {
    type: types.GET_FULL_PERSON_REQUEST,
    isFetchingFullPerson: true
  };
}

function requestFullPersonCompleted(personFullInfo) {
  return {
    type: types.GET_FULL_PERSON_COMPLETED,
    isFetchingFullPerson: false,
    personFullInfo
  };
}

function requestFullPersonError(personFullError) {
  return {
    type: types.GET_FULL_PERSON_ERROR,
    isFetchingFullPerson: false,
    personFullError
  };
}

function requestSystem() {
  return {
    type: types.GET_SYSTEM_INFO_REQUEST,
    isFetchingSystemn: true
  };
}

function requestSystemCompleted(systemInfo) {
  return {
    type: types.GET_SYSTEM_INFO_COMPLETED,
    isFetchingSystemn: false,
    systemInfo
  };
}

function requestSystemError(systemError) {
  return {
    type: types.GET_SYSTEM_INFO_ERROR,
    isFetchingSystemn: false,
    systemError
  };
}

function requestDocPerson() {
  return {
    type: types.GET_DOC_PERSON_REQUEST,
    isFetchingDocPerson: true
  };
}

function requestDocPersonCompleted(personDocInfo) {
  return {
    type: types.GET_DOC_PERSON_COMPLETED,
    isFetchingDocPerson: false,
    personDocInfo
  };
}

function requestDocPersonError(personDocError) {
  return {
    type: types.GET_DOC_PERSON_ERROR,
    isFetchingDocPerson: false,
    personDocError
  };
}

function requestMunicipals() {
  return {
    type: types.GET_MUNICIPALS_REQUEST,
    isFetchingMunicipals: true
  };
}

function requestMunicipalsCompleted(municipals) {
  return {
    type: types.GET_MUNICIPALS_COMPLETED,
    isFetchingMunicipals: false,
    municipals
  };
}

function requestMunicipalsError(municipalsError) {
  return {
    type: types.GET_MUNICIPALS_ERROR,
    isFetchingMunicipals: false,
    municipalsError
  };
}

/*function requestPosts() {
  return {
    type: types.GET_POSTS_REQUEST,
    isFetchingPosts: true
  };
}

function requestPostsCompleted(posts) {
  return {
    type: types.GET_POSTS_COMPLETED,
    isFetchingPosts: false,
    posts
  };
}

function requestPostsError(postsError) {
  return {
    type: types.GET_POSTS_ERROR,
    isFetchingPosts: false,
    postsError
  };
}*/

function requestOrganizations() {
  return {
    type: types.GET_ORGANIZATIONS_REQUEST,
    isFetchingOrganizations: true
  };
}

function requestOrganizationsCompleted(organizations) {
  return {
    type: types.GET_ORGANIZATIONS_COMPLETED,
    isFetchingOrganizations: false,
    organizations
  };
}

function requestOrganizationsError(organizationsError) {
  return {
    type: types.GET_ORGANIZATIONS_ERROR,
    isFetchingOrganizations: false,
    organizationsError
  };
}

function requestDepartments() {
  return {
    type: types.GET_DEPARTMENTS_REQUEST,
    isFetchingDepartments: true
  };
}

function requestDepartmentsCompleted(departments) {
  return {
    type: types.GET_DEPARTMENTS_COMPLETED,
    isFetchingDepartments: false,
    departments
  };
}

function requestDepartmentsError(departmentsError) {
  return {
    type: types.GET_DEPARTMENTS_ERROR,
    isFetchingDepartments: false,
    departmentsError
  };
}

export function getPersons() {
  return dispatch => {
    dispatch(requestPersons());
    return api
      .getPersonsList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonsError(message));
        } else {
          logError(err);
          dispatch(requestPersonsError(createError("Не удалось загрузить список специалистов")));
        }
      });
  };
}

export function getPersonRoles(id) {
  return dispatch => {
    dispatch(requestPersonRoles());
    return api
      .getPersonRoles(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonRolesCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonRolesError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonRolesError(createError("Не удалось загрузить список ролей")));
        }
      });
  };
}

export function getPersonWorldSkills(id) {
  return dispatch => {
    dispatch(requestPersonWs());
    return api
      .getPersonWorldSkills(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonWsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonWsError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonWsError(createError("Не удалось загрузить список компетенций")));
        }
      });
  };
}

export function getPersonSkills(id) {
  return dispatch => {
    dispatch(requestPersonSkills());
    return api
      .getPersonSkills(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonSkillsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonSkillsError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonSkillsError(createError("Не удалось загрузить список навыков")));
        }
      });
  };
}

export function getPersonAttachments() {
  return (dispatch, getState) => {
    dispatch(requestPersonAttachments());
    const id = getState().persons.personFullInfo.info.id;
    return api
      .getPersonDocumentAttachments(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonAttachmentsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonAttachmentsError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonAttachmentsError(createError("Не удалось загрузить список документов")));
        }
      });
  };
}

export function getPersonSnilsAttachments() {
  return (dispatch, getState) => {
    dispatch(requestPersonSnilsAttachments());
    const id = getState().persons.personFullInfo.info.id;
    return api
      .getPersonSnilsAttachments(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonSnilsAttachmentsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonSnilsAttachmentsError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonSnilsAttachmentsError(createError("Не удалось загрузить список файлов СНИЛС")));
        }
      });
  };
}

export function getPersonHistory() {
  return (dispatch, getState) => {
    dispatch(requestPersonHistory());
    const id = getState().persons.personFullInfo.info.id;
    return api
      .getPersonHistory(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonHistoryCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonHistoryError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonHistoryError(createError("Не удалось загрузить историю")));
        }
      });
  };
}

export function getPerson(id) {
  return dispatch => {
    dispatch(requestPerson());
    return api
      .getPersonCard(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestPersonError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonError(createError("Не удалось получить данные о специалисте")));
        }
      });
  };
}

export function getFullPerson(id) {
  return dispatch => {
    dispatch(requestFullPerson());
    return api
      .getPersonFullInfo(id)
      .then(response => {
        if (response.status === 200) {
          let person = response.data;
          person = {
            info: person.info,
            data: person.data
          };

          dispatch(requestFullPersonCompleted(person));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestFullPersonError(err.response));
        } else {
          logError(err);
          dispatch(requestFullPersonError(createError("Не удалось загрузить данные о стециалисте")));
        }
      });
  };
}

export function getSystemInfo(id) {
  return dispatch => {
    dispatch(requestSystem());
    return api
      .getSystemInfo(id)
      .then(response => {
        if (response.status === 200) {
          let system = response.data;
          system = {
            ...system,
            info: {
              ...system.info
            }
          };

          dispatch(requestSystemCompleted(system));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestSystemError(err.response));
        } else {
          logError(err);
          dispatch(requestSystemError(createError("Не удалось загрузить данные об учётной записи")));
        }
      });
  };
}

export function getDocPerson(id) {
  return dispatch => {
    dispatch(requestDocPerson());
    return api
      .getPersonDocument(id)
      .then(response => {
        if (response.status === 200) {
          let doc = response.data;
          doc = {
            ...doc,
            data: {
              ...doc.data,
            }
          };
          dispatch(requestDocPersonCompleted(doc));
        }
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({message}) => message).join(", ");
            }
            logError(message);
            dispatch(requestDocPersonError(err.response));
          } else if (err.response.status === 404) {
            dispatch(requestDocPersonCompleted(null));
          }
        } else {
          logError("Не удалось загрузить документ, удостоверяющий личность специалиста");
          dispatch(requestDocPersonError(createError("Не удалось загрузить документ, удостоверяющий личность специалиста")));
        }
      });
  };
}

export function getOrganizations() {
  return dispatch => {
    dispatch(requestOrganizations());
    return api
      .getOrganizationsList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestOrganizationsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestOrganizationsError(err.response));
        } else {
          logError(err);
          dispatch(requestOrganizationsError(createError("Не удалось получить список организаций")));
        }
      });
  };
}

/*export function getPosts() {
  return dispatch => {
    dispatch(requestPosts());
    return api
      .getPostsList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPostsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestPostsError(err.response));
        } else {
          logError(err);
          dispatch(requestPostsError(createError("Не удалось получить список должностей")));
        }
      });
  };
}*/

export function getDepartments(id) {
  return dispatch => {
    dispatch(requestDepartments());
    return api
      .getDepartments(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestDepartmentsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestDepartmentsError(err.response));
        } else {
          logError(err);
          dispatch(requestDepartmentsError(createError("Не удалось получить список подразделений")));
        }
      });
  };
}

export function getMunicipals(region) {
  return dispatch => {
    dispatch(requestMunicipals());
    return api
      .getMunicipalsList(region)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestMunicipalsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestMunicipalsError(err.response));
        } else {
          logError(err);
          dispatch(requestMunicipalsError(createError("Не удалось получить писок муниципальных образований")));
        }
      });
  };
}

function requestPersonOrganizations() {
  return {
    type: types.GET_PERSON_ORGANIZATIONS_REQUEST,
    isFetchingPersonOrgList: true
  };
}

function requestPersonOrganizationsCompleted(personOrgList) {
  return {
    type: types.GET_PERSON_ORGANIZATIONS_COMPLETED,
    isFetchingPersonOrgList: false,
    personOrgList
  };
}

function requestPersonOrganizationsError(personOrgListError) {
  return {
    type: types.GET_PERSON_ORGANIZATIONS_ERROR,
    isFetchingPersonOrgList: false,
    personOrgListError
  };
}

export function getPersonOrganizationList(id) {
  return dispatch => {
    dispatch(requestPersonOrganizations());
    return api
      .getPersonOrganizations(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestPersonOrganizationsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          logError(err.response);
          dispatch(requestPersonOrganizationsError(err.response));
        } else {
          logError(err);
          dispatch(requestPersonOrganizationsError(createError("Не удалось получить писок организаций пользователя")));
        }
      });
  };
}

export default {
  getPersons,
  getPersonRoles,
  getPersonWorldSkills,
  getPersonSkills,
  getPersonOrganizationList,
  getPersonHistory,
  getPerson,
  getFullPerson,
  getSystemInfo,
  getPersonAttachments,
  getPersonSnilsAttachments,
  getDocPerson,
  getMunicipals,
  getOrganizations,
  getDepartments
  //getPosts
};
